import React from "react";
import DocMetaForm from "../components/Forms/DocMetaForm";
import { Content, Container } from "../pages/Template";
import { isMobile } from "../helpers";
import { RouteMatch } from "../lib";

type Props = {
    match: RouteMatch;
};

export class DocMetaPage extends React.Component<Props> {
    static paths = ["/app/doc/meta/:doc_id"];
    static requiresAuth = true;

    render() {
        return (
            <Content isLandingPage={isMobile()}>
                <Container width="500px">
                    <DocMetaForm
                        doc_id={parseInt(this.props.match.params.doc_id)}
                        match={this.props.match}
                    />
                </Container>
            </Content>
        );
    }
}
